import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { PackComparisonTable } from './PackComparisonTable';
const upsellComparisons = [{
  situation: 'El pelotón pica fuerte',
  bad: 'Respondés sin criterio y explotás',
  good: 'Sabés exactamente cuándo y cómo responder'
}, {
  situation: 'Cambia el viento',
  bad: 'Te perdés y perdés posición',
  good: 'Conocés el abanico y el echelon'
}, {
  situation: 'Subida larga de 20 minutos',
  bad: 'Salís demasiado fuerte y llegás solo',
  good: 'Tenés el mapa táctico para cada tipo de subida'
}, {
  situation: 'Salida grupal intensa',
  bad: 'Chupás rueda o te destruís tirando punta',
  good: 'Sabés rotar sin gastar de más'
}, {
  situation: 'Llegada al final',
  bad: 'Sin criterio de posición',
  good: 'Posicionamiento definido según terreno y viento'
}, {
  situation: 'Tu cabeza en el momento difícil',
  bad: 'Dudás y aflojás',
  good: 'Los 5 principios del ciclista que mejora'
}];
export function UpsellSection() {
  return <section className="py-20 px-4 bg-slate-950 text-center border-t border-slate-800/50" data-id="element-397">
      <div className="max-w-4xl mx-auto" data-id="element-398">
        <FadeIn data-id="element-399">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-6 leading-tight" data-id="element-400">
            🔩 ¿QUÉ AGREGA EL PELOTÓN 10X?
          </h2>
          <p className="text-xl text-slate-400 mb-12" data-id="element-401">
            El sistema completo para rendir en grupo, no solo en solitario.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-402">
          <div className="bg-slate-900 rounded-2xl border border-slate-700 overflow-hidden shadow-xl mb-16 text-left" data-id="element-403">
            <div className="overflow-x-auto" data-id="element-404">
              <table className="w-full min-w-[600px]" role="table" aria-label="Comparación con y sin Pelotón 10X" data-id="element-405">
                <thead data-id="element-406">
                  <tr className="bg-slate-950 border-b border-slate-700" data-id="element-407">
                    <th scope="col" className="p-5 text-left text-slate-300 font-bold" data-id="element-408">
                      Situación en la salida
                    </th>
                    <th scope="col" className="p-5 text-left text-red-500 font-bold border-l border-slate-700" data-id="element-409">
                      <span aria-hidden="true" data-id="element-410">❌</span> Sin Pelotón 10X
                    </th>
                    <th scope="col" className="p-5 text-left text-green-500 font-bold border-l border-slate-700" data-id="element-411">
                      <span aria-hidden="true" data-id="element-412">✅</span> Con Pelotón 10X
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-800" data-id="element-413">
                  {upsellComparisons.map((row, i) => <tr key={i} data-id="element-414">
                      <td className="p-5 text-slate-300 font-medium" data-id="element-415">
                        {row.situation}
                      </td>
                      <td className="p-5 text-slate-400 text-sm border-l border-slate-800" data-id="element-416">
                        {row.bad}
                      </td>
                      <td className="p-5 text-white font-bold text-sm border-l border-slate-800" data-id="element-417">
                        {row.good}
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-418">
          <div className="bg-slate-900/50 rounded-2xl p-8 md:p-10 text-left border border-slate-800 max-w-2xl mx-auto mb-20" data-id="element-419">
            <h3 className="text-xl font-bold text-white mb-6 flex items-center gap-2" data-id="element-420">
              <span className="text-green-500" data-id="element-421">✅</span> EL PELOTÓN 10X INCLUYE:
            </h3>
            <ul className="space-y-4" data-id="element-422">
              {['Sistema de posicionamiento en pelotón según terreno y viento', 'Mapa de tácticas de subida para llegar arriba con el grupo', 'Protocolo de rotación sin destruirte ni chupar rueda todo el tiempo', 'Gestión del viento para rutas pampeanas, cordobesas y patagónicas', 'Los 5 principios mentales del ciclista que mejora constantemente'].map((item, i) => <li key={i} className="flex gap-3 items-start" data-id="element-423">
                  <div className="flex-shrink-0 mt-1 text-green-500 font-bold" data-id="element-424">
                    ✓
                  </div>
                  <div className="text-slate-300 leading-relaxed" data-id="element-425">{item}</div>
                </li>)}
            </ul>
          </div>
        </FadeIn>

        {/* Pack Comparison Table */}
        <FadeIn delay={0.5} data-id="element-426">
          <div className="text-center mb-8" data-id="element-427">
            <h3 className="text-2xl md:text-3xl font-serif font-bold text-white tracking-wide" data-id="element-428">
              PACK BASE vs PACK COMPLETO
            </h3>
          </div>
          <div className="-mx-4 md:mx-0 mb-16" data-id="element-429">
            <PackComparisonTable data-id="element-430" />
          </div>
        </FadeIn>

        {/* Final CTA Section — moved from PricingSection */}
        <div className="max-w-2xl mx-auto space-y-8 text-center" data-id="element-431">
          <FadeIn delay={0.6} data-id="element-432">
            <p className="text-red-500 font-bold flex items-center justify-center gap-2 text-lg" data-id="element-433">
              🔴 ELEGÍ TU OPCIÓN:
            </p>
          </FadeIn>

          {/* Option A */}
          <FadeIn delay={0.7} data-id="element-434">
            <div className="bg-slate-900 border-2 border-green-500/40 rounded-2xl p-8 shadow-lg" data-id="element-435">
              <p className="text-red-500 font-bold text-sm tracking-wider mb-4" data-id="element-436">
                OPCIÓN A — PACK COMPLETO RECOMENDADO
              </p>
              <h4 className="text-2xl md:text-3xl text-white font-bold mb-6" data-id="element-437">
                PROTORRENDA 4-12 + Pelotón 10X
              </h4>
              <div className="flex items-center justify-center gap-3 mb-8" data-id="element-438">
                <span className="text-slate-500 line-through text-lg" data-id="element-439">
                  $69.990
                </span>
                <span className="text-slate-400" data-id="element-440">→</span>
                <span className="text-3xl font-black text-green-500" data-id="element-441">
                  $29.990
                </span>
                <span className="text-slate-400 text-sm" data-id="element-442">ARS</span>
              </div>

              <a href="https://fegion.shop/cart/46201151553675:1" target="_blank" rel="noopener noreferrer" className="w-full block text-center py-5 px-6 rounded-xl bg-green-600 hover:bg-green-500 text-white font-black text-xl transition-colors shadow-lg mb-6" aria-label="Comprar Pack Completo PROTORRENDA 4-12 + Pelotón 10X por $29.990" data-id="element-443">
                → SÍ, QUIERO EL COMBO COMPLETO ←
              </a>

              <div className="flex flex-wrap justify-center gap-3 text-sm text-slate-400" data-id="element-444">
                <span data-id="element-445">✅ Todo incluido</span>
                <span data-id="element-446">·</span>
                <span data-id="element-447">✅ Acceso inmediato</span>
                <span data-id="element-448">·</span>
                <span data-id="element-449">✅ Garantía 7 días</span>
              </div>
            </div>
          </FadeIn>

          {/* Divider */}
          <FadeIn delay={0.8} data-id="element-450">
            <div className="flex items-center gap-4 py-2" data-id="element-451">
              <div className="flex-grow border-t border-slate-800" data-id="element-452"></div>
              <span className="text-slate-600 text-sm" data-id="element-453">o</span>
              <div className="flex-grow border-t border-slate-800" data-id="element-454"></div>
            </div>
          </FadeIn>

          {/* Option B */}
          <FadeIn delay={0.9} data-id="element-455">
            <div data-id="element-456">
              <p className="text-slate-500 font-bold text-sm tracking-wider mb-3" data-id="element-457">
                OPCIÓN B — PACK BASE PROTORRENDA 4-12
              </p>
              <p className="text-2xl font-bold text-white mb-6" data-id="element-458">$19.990 ARS</p>
              <a href="https://fegion.shop/cart/46201145950347:1" target="_blank" rel="noopener noreferrer" className="w-full block text-center py-4 px-6 rounded-xl bg-amber-600 hover:bg-amber-500 text-white font-bold text-lg transition-colors" aria-label="Comprar solo el Pack Base de PROTORRENDA 4-12 por $19.990" data-id="element-459">
                Quiero el Pack Base de PROTORRENDA 4-12
              </a>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}